import React from 'react';
import { Box } from '@mui/material';

const bar = (active) => ({
  bgcolor: active ? 'primary.main' : 'action.active',
  borderRadius: '1px',
});

/** Small schematic icon for each gallery view type (22×22). */
export function GalleryLayoutIcon({ type, active }) {
  const b = bar(active);
  switch (type) {
    case 'horizontal':
      return (
        <Box sx={{ width: 22, height: 22, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '3px', alignItems: 'stretch' }}>
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
        </Box>
      );
    case 'vertical':
      return (
        <Box sx={{ width: 22, height: 22, display: 'grid', gridTemplateRows: '1fr 1fr 1fr', gap: '3px' }}>
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
        </Box>
      );
    case 'grid1':
      return (
        <Box sx={{ width: 22, height: 22, display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <Box sx={{ display: 'flex', gap: '3px', flex: 1, minHeight: 0 }}>
            <Box sx={{ ...b, flex: 1 }} />
            <Box sx={{ ...b, flex: 1 }} />
          </Box>
          <Box sx={{ ...b, height: 8 }} />
        </Box>
      );
    case 'grid2':
      return (
        <Box sx={{ width: 22, height: 22, display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <Box sx={{ ...b, height: 8 }} />
          <Box sx={{ display: 'flex', gap: '3px', flex: 1, minHeight: 0 }}>
            <Box sx={{ ...b, flex: 1 }} />
            <Box sx={{ ...b, flex: 1 }} />
          </Box>
        </Box>
      );
    case 'grid3':
      return (
        <Box sx={{ width: 22, height: 22, display: 'flex', gap: '3px' }}>
          <Box sx={{ ...b, width: 9, alignSelf: 'stretch' }} />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '3px', minWidth: 0 }}>
            <Box sx={{ ...b, flex: 1 }} />
            <Box sx={{ ...b, flex: 1 }} />
          </Box>
        </Box>
      );
    case 'grid4':
      return (
        <Box sx={{ width: 22, height: 22, display: 'flex', gap: '3px' }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '3px', minWidth: 0 }}>
            <Box sx={{ ...b, flex: 1 }} />
            <Box sx={{ ...b, flex: 1 }} />
          </Box>
          <Box sx={{ ...b, width: 9, alignSelf: 'stretch' }} />
        </Box>
      );
    case 'grid5':
      return (
        <Box sx={{ width: 22, height: 22, display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '1fr 1fr', gap: '3px' }}>
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
        </Box>
      );
    case 'grid6':
      return (
        <Box sx={{ width: 22, height: 22, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: '1fr 1fr', gap: '2px' }}>
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
          <Box sx={b} />
        </Box>
      );
    default:
      return <Box sx={{ width: 22, height: 22 }} />;
  }
}
